import { CanActivateFn, Router } from '@angular/router';
import { CentralService } from "../services/central.service";
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { jwtDecode } from "jwt-decode";

function parseRoles(value: any): string[] {
  if (Array.isArray(value)) {
    return value.flatMap(item => parseRoles(item));
  }

  if (value && typeof value === 'object') {
    return Object.values(value).flatMap(item => parseRoles(item));
  }

  if (typeof value === 'string') {
    const raw = value.trim();
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      if (parsed !== value) {
        return parseRoles(parsed);
      }
    } catch {
      // no-op
    }

    return raw.match(/[A-Za-zÁÉÍÓÚáéíóúÑñ]+/g) || [];
  }

  return [];
}

function getRolesFromToken(decodedToken: any): string[] {
  return [
    ...parseRoles(decodedToken?.UserTypeArray),
    ...parseRoles(decodedToken?.role),
    ...parseRoles(decodedToken?.roles),
    ...parseRoles(decodedToken?.authorities),
    ...parseRoles(decodedToken?.usertype),
    ...parseRoles(decodedToken?.user_type),
    ...parseRoles(decodedToken?.userTypeArray),
    ...parseRoles(decodedToken?.user_type_array),
    ...parseRoles(decodedToken?.userTypes),
    ...parseRoles(decodedToken?.userType)
  ];
}

function resolveUserRoles(authService: CentralService, decodedToken: any): string[] {
  const mergedRoles = [
    ...parseRoles(authService.usuario?.UserTypeArray),
    ...parseRoles(localStorage.getItem('userTypeArray')),
    ...getRolesFromToken(decodedToken)
  ];

  return mergedRoles
    .map(role => normalizeRole(role))
    .filter(role => role.length > 0);
}

function normalizeRole(value: string): string {
  return (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s_-]+/g, '')
    .trim()
    .toLowerCase();
}

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(CentralService);
  const router = inject(Router);
  const token = localStorage.getItem('token');
  const blockedRoles = (route.data?.['blockedRoles'] as string[]) || [];


  if (token === null || token === '') {
    authService.setDeeplinkCookiesFromParams(route.queryParamMap);
    return of(router.createUrlTree(['/bienvenida']));
  }

  let decodeToken: any;
  try {
    decodeToken = jwtDecode(token);
  } catch (error) {
    authService.logout();
    return of(router.createUrlTree(['/bienvenida']));
  }

  const isExpired = decodeToken && decodeToken.exp ? decodeToken.exp < Date.now() / 1000 : false;
   
  if (isExpired){
    authService.logout();
    return of(router.createUrlTree(['/bienvenida']));
  }

  const normalizedBlockedRoles = blockedRoles.map(role => normalizeRole(role));
  const tokenRoles = getRolesFromToken(decodeToken)
    .map(role => normalizeRole(role))
    .filter(role => role.length > 0);

  const blockedByToken = tokenRoles.some(tokenRole =>
    normalizedBlockedRoles.includes(tokenRole)
  );

  if (blockedByToken) {
    return of(router.createUrlTree(['/inicio']));
  }

  return authService.isLoggedIn()
    .pipe(
      map(valid => {
        if (valid !== true) {
          return router.createUrlTree(['/bienvenida']);
        }

        if (!blockedRoles.length) {
          return true;
        }

        const userRoles = resolveUserRoles(authService, decodeToken);
        if (!userRoles.length) {
          return router.createUrlTree(['/inicio']);
        }

        const hasBlockedRole = userRoles.some(userRole =>
          normalizedBlockedRoles.includes(userRole)
        );

        return hasBlockedRole ? router.createUrlTree(['/inicio']) : true;
      }),
      catchError(() => of(router.createUrlTree(['/bienvenida'])))
    );

  // if (authService.tieneToken()) {
  //   return true;
  // }else{
  //   const urlTree = router.createUrlTree(['/bienvenida'])
  //   return authService.isLoggedIn()
  //   .pipe(
  //     tap(valid => {
  //       if (!valid) {


  //         return urlTree
  //       }else{
  //         return
  //       }
  //     })
  //   );
  // }




};
